import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * A guest's name must contain a letter, in any script, so "1234", "12 34"
 * or "!!" can't be saved as a name. An empty value is left to `required`.
 */
export function isGuestName(value: string | null | undefined): boolean {
  return /\p{L}/u.test(value ?? '');
}

/** `{ noLetters: true }` when a non-empty name has no letter in it. */
export function guestNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = typeof control.value === 'string' ? control.value.trim() : '';
    return value && !isGuestName(value) ? { noLetters: true } : null;
  };
}
